<template>
  <div
    :class="[
      'fixed left-0 right-0 top-0 z-30 bg-white transition-all duration-300 ease-in-out',
      isSidebarOpen ? 'ml-64 sm:ml-72' : 'ml-0'
    ]"
  >
    <FormProgress />
    <div class="relative flex h-16 items-center justify-center sm:h-20">
      <ClientPortalItemsHeader
        :title="title"
        usedBy="QUESTIONNAIRE"
        :is-external="isExternal"
        :isSidebarOpen="isSidebarOpen"
      />
      <div
        class="absolute right-4 top-5 hidden whitespace-nowrap text-right font-[Inter] text-xs font-semibold
          leading-tight tracking-tight text-black sm:right-10 sm:text-sm md:right-16 md:text-base
          lg:right-[20px] lg:top-[40px] lg:block"
      >
        <!-- {{ displayField + 1 }} von {{ totalCount }} Fragen beantwortet -->
      </div>
    </div>
  </div>
</template>

<script setup>
  import FormProgress from './formProgress.vue'
  import { computed } from 'vue'
  import ClientPortalItemsHeader from '@/components/clientPortal/clientPortalItemsHeader.vue'

  defineEmits(['previousQuestion', 'next'])

  const props = defineProps({
    isFirstField: {
      type: Boolean,
      default: true
    },
    isLastField: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    totalCount: {
      type: Number,
      default: 0
    },
    activeField: {
      type: Number,
      default: 0
    },
    isExternal: {
      type: Boolean,
      default: false
    },
    isSidebarOpen: {
      type: Boolean,
      default: true
    }
  })

  const displayField = computed(() => {
    return props.activeField > props.totalCount ? props.activeField - 1 : props.activeField
  })
</script>
